module.exports = __webpack_public_path__ + "static/img/isNoMessage.daf5b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/race/isNoMessage.png
// module id = V85o
// module chunks = 2